import React from 'react';
import { HolographicButton } from '../components/HolographicButton';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, ShieldCheck, Zap } from 'lucide-react';
export function Closing() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(600);
  const trackAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Kit de Supervivencia: Ventas por DM',
        currency: 'COP',
        value: 29999
      });
    }
  };
  return <section className="py-20 bg-graphite text-white relative overflow-hidden" data-id="element-64">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-accent to-success" data-id="element-65"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-primary opacity-20 rounded-full blur-3xl" data-id="element-66"></div>
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-accent opacity-10 rounded-full blur-3xl" data-id="element-67"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-68">
        <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-69">
          Deja de Perder Tiempo Hoy: Últimas Horas de esta Oferta
        </h2>

        <div className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-3 mb-10" data-id="element-70">
          <span className="text-gray-300 font-medium" data-id="element-71">
            La oferta expira en:
          </span>
          <span className="font-mono text-2xl font-bold text-accent tracking-wider" data-id="element-72">
            {hours}:{minutes}:{seconds}
          </span>
        </div>

        <div className="max-w-2xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8 mb-10 text-left" data-id="element-73">
          <ul className="space-y-4" data-id="element-74">
            {["Responde '¿precio?' con autoridad (sin espantar)", 'Recupera ventas perdidas con el Protocolo 24h', 'Cierra más en menos tiempo, sin vivir pegada al celular'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-75">
                <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0 mt-0.5" data-id="element-76" />
                <span className="text-lg text-gray-200" data-id="element-77">{bullet}</span>
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-78">
          <HolographicButton variant="success" size="xl" href="https://krove.lat//cart/40650717790337:1" id="buyNowBottom" onClick={trackAddToCart} className="w-full md:w-auto min-w-[300px] animate-pulse-glow" data-id="element-79">
            Comprar ahora por $29.999 COP
          </HolographicButton>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-400 mt-2" data-id="element-80">
            <div className="flex items-center gap-1" data-id="element-81">
              <Zap className="w-4 h-4" data-id="element-82" />
              <span data-id="element-83">Entrega inmediata por email</span>
            </div>
            <span className="hidden md:inline" data-id="element-84">•</span>
            <div className="flex items-center gap-1" data-id="element-85">
              <ShieldCheck className="w-4 h-4" data-id="element-86" />
              <span data-id="element-87">Garantía 7 días</span>
            </div>
            <span className="hidden md:inline" data-id="element-88">•</span>
            <div className="flex items-center gap-1" data-id="element-89">
              <ShieldCheck className="w-4 h-4" data-id="element-90" />
              <span data-id="element-91">Pago seguro</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}